import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export default function AdminTickets() {
  const { t } = useT();
  const [tickets, setTickets] = useState([]);
  const load = () => api.get("/admin/tickets").then((r) => setTickets(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/tickets/${id}`, null, { params: { status } });
      toast.success("Updated");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <DashboardShell title={t("admin.ticketsTitle")} subtitle={t("admin.ticketsSubtitle")}>
      <div className="am-card p-2 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-muted-foreground border-b">
              <th className="px-4 py-3">{t("admin.from")}</th>
              <th className="px-4 py-3">{t("admin.subject")}</th>
              <th className="px-4 py-3">{t("admin.message")}</th>
              <th className="px-4 py-3">{t("common.status")}</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((tk) => (
              <tr key={tk.ticket_id} className="border-b last:border-0">
                <td className="px-4 py-3 font-semibold">{tk.from_name}</td>
                <td className="px-4 py-3">{tk.subject}</td>
                <td className="px-4 py-3 text-muted-foreground max-w-md truncate">{tk.message}</td>
                <td className="px-4 py-3"><span className="am-chip capitalize">{tk.status.replace("_", " ")}</span></td>
                <td className="px-4 py-3 space-x-2 text-right">
                  {tk.status !== "in_progress" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => setStatus(tk.ticket_id, "in_progress")}>{t("admin.pickUp")}</Button>}
                  {tk.status !== "resolved" && <Button size="sm" className="rounded-full am-btn-primary" onClick={() => setStatus(tk.ticket_id, "resolved")}>{t("admin.resolve")}</Button>}
                </td>
              </tr>
            ))}
            {tickets.length === 0 && <tr><td colSpan={5} className="py-12 text-center text-muted-foreground">{t("sub.noData")}</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
